export class ContactDispositionApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get All Dispositions for contact
     * @returns ContactDisposition
     * @throws ApiError
     */
    getContactDispositions({ contactId, pageSize, page, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/contact-disposition',
            query: {
                'pageSize': pageSize,
                'page': page,
                'contactId': contactId,
            },
        });
    }
}
